/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".browser-logo[_ngcontent-%COMP%]{margin-right:10px;height:25px;width:25px}.snackbar-close-button[_ngcontent-%COMP%]{position:absolute;right:5%;top:5%}"];
export { styles as styles };

